import React from 'react';
import { Field } from 'redux-form';
import Tooltip from '../../../../shared/components/widgets/Tooltip';
import { renderFieldForm } from '../../shared/formComponents';
import AudienceFields from './shared/AudienceFields';

/**
 * Target Budget Fields Component
 * Captures Target-specific IDs stored in budget_json.target
 */
const TargetBudgetFields = () => (
  <>
    {/* Brand Name - stored in the brand_name column */}
    <div className="form__form-group">
      <span className="form__form-group-label">
        Brand Name{' '}
        <Tooltip
          id="targetBrandName"
          msg="Enter the brand name associated with this budget. This will be used to identify the brand in budget reports."
          placement="top"
        />
      </span>
      <div className="form__form-group-field">
        <Field
          name="targetBrandName"
          component={renderFieldForm}
          placeholder="Enter brand name"
        />
      </div>
    </div>

    {/* Promoted Brand IDs - stored at budget_json.target.promotedBrandIds */}
    <AudienceFields
      name="targetPromotedBrandIds"
      label="Promoted Brand IDs"
      tooltip="Add the Target promoted brand IDs for this budget"
      placeholder="Enter a promoted brand ID"
      addButtonLabel="Add Promoted Brand ID"
    />

    {/* Drawable Balance IDs - stored at budget_json.target.drawableBalanceIds */}
    <AudienceFields
      name="targetDrawableBalanceIds"
      label="Drawable Balance IDs"
      tooltip="Add the Target drawable balance IDs for this budget"
      placeholder="Enter a drawable balance ID"
      addButtonLabel="Add Drawable Balance ID"
    />
  </>
);

export default TargetBudgetFields;
